import React from 'react';
import BaseIcon from './BaseIcon';


const SendForSignatureIcon = props => (
  <BaseIcon {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path d="M2,3 L2,13 L10.4080976,13 L13.6223833,8 L10.4080976,3 L2,3 Z M-4.88498131e-14,1 L11.5,1 L16,8 L11.5,15 L-4.88498131e-14,15 L-4.88498131e-14,1 Z M6.75,6.58578644 L8.54289322,4.79289322 C8.93341751,4.40236893 9.56658249,4.40236893 9.95710678,4.79289322 C10.3476311,5.18341751 10.3476311,5.81658249 9.95710678,6.20710678 L8.16421356,8 L9.95710678,9.79289322 C10.3476311,10.1834175 10.3476311,10.8165825 9.95710678,11.2071068 C9.56658249,11.5976311 8.93341751,11.5976311 8.54289322,11.2071068 L6.75,9.41421356 L4.95710678,11.2071068 C4.56658249,11.5976311 3.93341751,11.5976311 3.54289322,11.2071068 C3.15236893,10.8165825 3.15236893,10.1834175 3.54289322,9.79289322 L5.33578644,8 L3.54289322,6.20710678 C3.15236893,5.81658249 3.15236893,5.18341751 3.54289322,4.79289322 C3.93341751,4.40236893 4.56658249,4.40236893 4.95710678,4.79289322 L6.75,6.58578644 Z" fillRule="nonzero" />
    </g>
  </BaseIcon>
);


export default SendForSignatureIcon;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Icons/SendForSignatureIcon.jsx